import { render, staticRenderFns } from "./CompilationsHeaders.vue?vue&type=template&id=6b158ee2&scoped=true"
import script from "./CompilationsHeaders.vue?vue&type=script&lang=js"
export * from "./CompilationsHeaders.vue?vue&type=script&lang=js"
import style0 from "./CompilationsHeaders.vue?vue&type=style&index=0&id=6b158ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b158ee2",
  null
  
)

export default component.exports